import { j as v } from "./jsx-runtime-944c88e2.js";
import { S as Fe } from "./chunk-5PH6ULNP-da6977a4.js";
import { ak as R, al as D, am as qe, an as G, ao as k, ap as re, aq as ye, ar as ne, as as Q, at as Qe, au as W, av as q, aw as L, ax as $e, ay as Se, az as ie, aA as Be, aB as ze, aC as He, aD as M, aE as ge, aF as Ge, aG as xe, aH as Ke, aI as We, aJ as be, aK as Je, aL as Ye, aM as z, aN as Xe, aO as $, aP as Ze, aQ as et, aR as we, aS as tt, aT as rt, aU as nt, aV as it, aW as st, aX as ot, aY as at, aZ as ut, a_ as ct, a$ as lt, b0 as dt, b1 as ft, b2 as ht, b3 as Ae, b4 as pt, b5 as vt, b6 as mt, T as j, u as yt, b7 as St, b8 as _e, b9 as gt } from "./eMyAsurionProvider-729b3d93.js";
import { g as xt, l as Ee } from "./lodash-9598aa3c.js";
import * as De from "react";
import Z, { useLayoutEffect as bt, useState as ve, useCallback as se, useEffect as wt } from "react";
import "@tanstack/react-query";
import "./useAccount-78ba59e2.js";
import "./myasurion-shared.mixpanel.es.js";
import { g as _t } from "./domains-7d097fe4.js";
import { Stack as Ne, Heading as Et, Text as J, Flex as K, Box as Y, CheckboxGroup as Ot, Checkbox as Tt, Button as Me, Center as Ct, Slider as It, SliderMark as Rt, SliderTrack as kt, SliderFilledTrack as Lt, SliderThumb as jt } from "@chakra-ui/react";
import { Icon as At } from "@chakra-ui/icons";
import "./features-b5f79a23.js";
import "./providers-0da5f61c.js";
import "react-router-dom";
import "./cleave-react-node-c4a374e5.js";
import "@react-oauth/google";
import "./chunk-DMO4EI7P-a11dff68.js";
import "@emotion/react";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
import "mixpanel-browser";
import "@emotion/styled";
var pe = { exports: {} }, oe = {}, H = { exports: {} }, ae = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oe;
function Dt() {
  if (Oe)
    return ae;
  Oe = 1;
  var t = Z;
  function e(o, u) {
    return o === u && (o !== 0 || 1 / o === 1 / u) || o !== o && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : e, n = t.useState, i = t.useEffect, a = t.useLayoutEffect, s = t.useDebugValue;
  function d(o, u) {
    var l = u(), h = n({ inst: { value: l, getSnapshot: u } }), S = h[0].inst, m = h[1];
    return a(function() {
      S.value = l, S.getSnapshot = u, f(S) && m({ inst: S });
    }, [o, l, u]), i(function() {
      return f(S) && m({ inst: S }), o(function() {
        f(S) && m({ inst: S });
      });
    }, [o]), s(l), l;
  }
  function f(o) {
    var u = o.getSnapshot;
    o = o.value;
    try {
      var l = u();
      return !r(o, l);
    } catch {
      return !0;
    }
  }
  function p(o, u) {
    return u();
  }
  var c = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? p : d;
  return ae.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : c, ae;
}
var ue = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Te;
function Nt() {
  return Te || (Te = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Z, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(g) {
      {
        for (var y = arguments.length, O = new Array(y > 1 ? y - 1 : 0), b = 1; b < y; b++)
          O[b - 1] = arguments[b];
        n("error", g, O);
      }
    }
    function n(g, y, O) {
      {
        var b = e.ReactDebugCurrentFrame, w = b.getStackAddendum();
        w !== "" && (y += "%s", O = O.concat([w]));
        var T = O.map(function(_) {
          return String(_);
        });
        T.unshift("Warning: " + y), Function.prototype.apply.call(console[g], console, T);
      }
    }
    function i(g, y) {
      return g === y && (g !== 0 || 1 / g === 1 / y) || g !== g && y !== y;
    }
    var a = typeof Object.is == "function" ? Object.is : i, s = t.useState, d = t.useEffect, f = t.useLayoutEffect, p = t.useDebugValue, c = !1, o = !1;
    function u(g, y, O) {
      c || t.startTransition !== void 0 && (c = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var b = y();
      if (!o) {
        var w = y();
        a(b, w) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), o = !0);
      }
      var T = s({
        inst: {
          value: b,
          getSnapshot: y
        }
      }), _ = T[0].inst, C = T[1];
      return f(function() {
        _.value = b, _.getSnapshot = y, l(_) && C({
          inst: _
        });
      }, [g, b, y]), d(function() {
        l(_) && C({
          inst: _
        });
        var V = function() {
          l(_) && C({
            inst: _
          });
        };
        return g(V);
      }, [g]), p(b), b;
    }
    function l(g) {
      var y = g.getSnapshot, O = g.value;
      try {
        var b = y();
        return !a(O, b);
      } catch {
        return !0;
      }
    }
    function h(g, y, O) {
      return y();
    }
    var S = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", m = !S, x = m ? h : u, E = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : x;
    ue.useSyncExternalStore = E, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), ue;
}
var Ce;
function Pe() {
  return Ce || (Ce = 1, process.env.NODE_ENV === "production" ? H.exports = Dt() : H.exports = Nt()), H.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ie;
function Mt() {
  if (Ie)
    return oe;
  Ie = 1;
  var t = Z, e = Pe();
  function r(p, c) {
    return p === c && (p !== 0 || 1 / p === 1 / c) || p !== p && c !== c;
  }
  var n = typeof Object.is == "function" ? Object.is : r, i = e.useSyncExternalStore, a = t.useRef, s = t.useEffect, d = t.useMemo, f = t.useDebugValue;
  return oe.useSyncExternalStoreWithSelector = function(p, c, o, u, l) {
    var h = a(null);
    if (h.current === null) {
      var S = { hasValue: !1, value: null };
      h.current = S;
    } else
      S = h.current;
    h = d(function() {
      function x(b) {
        if (!E) {
          if (E = !0, g = b, b = u(b), l !== void 0 && S.hasValue) {
            var w = S.value;
            if (l(w, b))
              return y = w;
          }
          return y = b;
        }
        if (w = y, n(g, b))
          return w;
        var T = u(b);
        return l !== void 0 && l(w, T) ? w : (g = b, y = T);
      }
      var E = !1, g, y, O = o === void 0 ? null : o;
      return [function() {
        return x(c());
      }, O === null ? void 0 : function() {
        return x(O());
      }];
    }, [c, o, u, l]);
    var m = i(p, h[0], h[1]);
    return s(function() {
      S.hasValue = !0, S.value = m;
    }, [m]), f(m), m;
  }, oe;
}
var ce = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Re;
function Pt() {
  return Re || (Re = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Z, e = Pe();
    function r(c, o) {
      return c === o && (c !== 0 || 1 / c === 1 / o) || c !== c && o !== o;
    }
    var n = typeof Object.is == "function" ? Object.is : r, i = e.useSyncExternalStore, a = t.useRef, s = t.useEffect, d = t.useMemo, f = t.useDebugValue;
    function p(c, o, u, l, h) {
      var S = a(null), m;
      S.current === null ? (m = {
        hasValue: !1,
        value: null
      }, S.current = m) : m = S.current;
      var x = d(function() {
        var O = !1, b, w, T = function(N) {
          if (!O) {
            O = !0, b = N;
            var U = l(N);
            if (h !== void 0 && m.hasValue) {
              var F = m.value;
              if (h(F, U))
                return w = F, F;
            }
            return w = U, U;
          }
          var Ue = b, ee = w;
          if (n(Ue, N))
            return ee;
          var te = l(N);
          return h !== void 0 && h(ee, te) ? ee : (b = N, w = te, te);
        }, _ = u === void 0 ? null : u, C = function() {
          return T(o());
        }, V = _ === null ? void 0 : function() {
          return T(_());
        };
        return [C, V];
      }, [o, u, l, h]), E = x[0], g = x[1], y = i(c, E, g);
      return s(function() {
        m.hasValue = !0, m.value = y;
      }, [y]), f(y), y;
    }
    ce.useSyncExternalStoreWithSelector = p, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), ce;
}
process.env.NODE_ENV === "production" ? pe.exports = Mt() : pe.exports = Pt();
var Vt = pe.exports, Ut = {
  deferEvents: !1
}, ke = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      this.processingEvent = !1, this.queue = [], this.initialized = !1, this.options = R(R({}, Ut), e);
    }
    return t.prototype.initialize = function(e) {
      if (this.initialized = !0, e) {
        if (!this.options.deferEvents) {
          this.schedule(e);
          return;
        }
        this.process(e);
      }
      this.flushEvents();
    }, t.prototype.schedule = function(e) {
      if (!this.initialized || this.processingEvent) {
        this.queue.push(e);
        return;
      }
      if (this.queue.length !== 0)
        throw new Error("Event queue should be empty when it is not processing events");
      this.process(e), this.flushEvents();
    }, t.prototype.clear = function() {
      this.queue = [];
    }, t.prototype.flushEvents = function() {
      for (var e = this.queue.shift(); e; )
        this.process(e), e = this.queue.shift();
    }, t.prototype.process = function(e) {
      this.processingEvent = !0;
      try {
        e();
      } catch (r) {
        throw this.clear(), r;
      } finally {
        this.processingEvent = !1;
      }
    }, t;
  }()
), le = /* @__PURE__ */ new Map(), Ft = 0, B = {
  bookId: function() {
    return "x:".concat(Ft++);
  },
  register: function(t, e) {
    return le.set(t, e), t;
  },
  get: function(t) {
    return le.get(t);
  },
  free: function(t) {
    le.delete(t);
  }
};
function me() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  D || console.warn("XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues");
}
function qt() {
  var t = me();
  if (t && "__xstate__" in t)
    return t.__xstate__;
}
function Qt(t) {
  if (me()) {
    var e = qt();
    e && e.register(t);
  }
}
function $t(t, e) {
  e === void 0 && (e = {});
  var r = t.initialState, n = /* @__PURE__ */ new Set(), i = [], a = !1, s = function() {
    if (!a) {
      for (a = !0; i.length > 0; ) {
        var p = i.shift();
        r = t.transition(r, p, f), n.forEach(function(c) {
          return c.next(r);
        });
      }
      a = !1;
    }
  }, d = qe({
    id: e.id,
    send: function(p) {
      i.push(p), s();
    },
    getSnapshot: function() {
      return r;
    },
    subscribe: function(p, c, o) {
      var u = G(p, c, o);
      return n.add(u), u.next(r), {
        unsubscribe: function() {
          n.delete(u);
        }
      };
    }
  }), f = {
    parent: e.parent,
    self: d,
    id: e.id || "anonymous",
    observers: n
  };
  return r = t.start ? t.start(f) : r, d;
}
var Bt = {
  sync: !1,
  autoForward: !1
}, I;
(function(t) {
  t[t.NotStarted = 0] = "NotStarted", t[t.Running = 1] = "Running", t[t.Stopped = 2] = "Stopped";
})(I || (I = {}));
var zt = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, r) {
      r === void 0 && (r = t.defaultOptions);
      var n = this;
      this.machine = e, this.delayedEventsMap = {}, this.listeners = /* @__PURE__ */ new Set(), this.contextListeners = /* @__PURE__ */ new Set(), this.stopListeners = /* @__PURE__ */ new Set(), this.doneListeners = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Set(), this.sendListeners = /* @__PURE__ */ new Set(), this.initialized = !1, this.status = I.NotStarted, this.children = /* @__PURE__ */ new Map(), this.forwardTo = /* @__PURE__ */ new Set(), this._outgoingQueue = [], this.init = this.start, this.send = function(c, o) {
        if (Ze(c))
          return n.batch(c), n.state;
        var u = L(et(c, o));
        if (n.status === I.Stopped)
          return D || M(!1, 'Event "'.concat(u.name, '" was sent to stopped service "').concat(n.machine.id, `". This service has already reached its final state, and will not transition.
Event: `).concat(JSON.stringify(u.data))), n.state;
        if (n.status !== I.Running && !n.options.deferEvents)
          throw new Error('Event "'.concat(u.name, '" was sent to uninitialized service "').concat(
            n.machine.id,
            `". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.
Event: `
          ).concat(JSON.stringify(u.data)));
        return n.scheduler.schedule(function() {
          n.forward(u);
          var l = n._nextState(u);
          n.update(l, u);
        }), n._state;
      }, this.sendTo = function(c, o, u) {
        var l = n.parent && (o === we.Parent || n.parent.id === o), h = l ? n.parent : tt(o) ? o === we.Internal ? n : n.children.get(o) || B.get(o) : rt(o) ? o : void 0;
        if (!h) {
          if (!l)
            throw new Error("Unable to send event to child '".concat(o, "' from service '").concat(n.id, "'."));
          D || M(!1, "Service '".concat(n.id, "' has no parent: unable to send event ").concat(c.type));
          return;
        }
        if ("machine" in h) {
          if (n.status !== I.Stopped || n.parent !== h || // we need to send events to the parent from exit handlers of a machine that reached its final state
          n.state.done) {
            var S = R(R({}, c), {
              name: c.name === nt ? "".concat(z(n.id)) : c.name,
              origin: n.sessionId
            });
            !u && n.machine.config.predictableActionArguments ? n._outgoingQueue.push([h, S]) : h.send(S);
          }
        } else
          !u && n.machine.config.predictableActionArguments ? n._outgoingQueue.push([h, c.data]) : h.send(c.data);
      }, this._exec = function(c, o, u, l) {
        l === void 0 && (l = n.machine.options.actions);
        var h = c.exec || it(c.type, l), S = q(h) ? h : h ? h.exec : c.exec;
        if (S)
          try {
            return S(o, u.data, n.machine.config.predictableActionArguments ? {
              action: c,
              _event: u
            } : {
              action: c,
              state: n.state,
              _event: u
            });
          } catch (F) {
            throw n.parent && n.parent.send({
              type: "xstate.error",
              data: F
            }), F;
          }
        switch (c.type) {
          case ft: {
            var m = c;
            n.defer(m);
            break;
          }
          case dt:
            var x = c;
            if (typeof x.delay == "number") {
              n.defer(x);
              return;
            } else
              x.to ? n.sendTo(x._event, x.to, u === re) : n.send(x._event);
            break;
          case lt:
            n.cancel(c.sendId);
            break;
          case at: {
            if (n.status !== I.Running)
              return;
            var E = c.activity;
            if (
              // in v4 with `predictableActionArguments` invokes are called eagerly when the `this.state` still points to the previous state
              !n.machine.config.predictableActionArguments && !n.state.activities[E.id || E.type]
            )
              break;
            if (E.type === ut.Invoke) {
              var g = ct(E.src), y = n.machine.options.services ? n.machine.options.services[g.type] : void 0, O = E.id, b = E.data;
              D || M(
                !("forward" in E),
                // tslint:disable-next-line:max-line-length
                "`forward` property is deprecated (found in invocation of '".concat(E.src, "' in in machine '").concat(n.machine.id, "'). ") + "Please use `autoForward` instead."
              );
              var w = "autoForward" in E ? E.autoForward : !!E.forward;
              if (!y) {
                D || M(!1, "No service found for invocation '".concat(E.src, "' in machine '").concat(n.machine.id, "'."));
                return;
              }
              var T = b ? ye(b, o, u) : void 0;
              if (typeof y == "string")
                return;
              var _ = q(y) ? y(o, u.data, {
                data: T,
                src: g,
                meta: E.meta
              }) : y;
              if (!_)
                return;
              var C = void 0;
              be(_) && (_ = T ? _.withContext(T) : _, C = {
                autoForward: w
              }), n.spawn(_, O, C);
            } else
              n.spawnActivity(E);
            break;
          }
          case ot: {
            n.stopChild(c.activity.id);
            break;
          }
          case st:
            var V = c, N = V.label, U = V.value;
            N ? n.logger(N, U) : n.logger(U);
            break;
          default:
            D || M(!1, "No implementation found for action type '".concat(c.type, "'"));
            break;
        }
      };
      var i = R(R({}, t.defaultOptions), r), a = i.clock, s = i.logger, d = i.parent, f = i.id, p = f !== void 0 ? f : e.id;
      this.id = p, this.logger = s, this.clock = a, this.parent = d, this.options = i, this.scheduler = new ke({
        deferEvents: this.options.deferEvents
      }), this.sessionId = B.bookId();
    }
    return Object.defineProperty(t.prototype, "initialState", {
      get: function() {
        var e = this;
        return this._initialState ? this._initialState : Q(this, function() {
          return e._initialState = e.machine.initialState, e._initialState;
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "state", {
      /**
       * @deprecated Use `.getSnapshot()` instead.
       */
      get: function() {
        return D || M(this.status !== I.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first.")), this._state;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.execute = function(e, r) {
      var n, i;
      try {
        for (var a = k(e.actions), s = a.next(); !s.done; s = a.next()) {
          var d = s.value;
          this.exec(d, e, r);
        }
      } catch (f) {
        n = {
          error: f
        };
      } finally {
        try {
          s && !s.done && (i = a.return) && i.call(a);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }, t.prototype.update = function(e, r) {
      var n, i, a, s, d, f, p, c, o = this;
      if (e._sessionid = this.sessionId, this._state = e, (!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
      // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
      r === re) && this.options.execute)
        this.execute(this.state);
      else
        for (var u = void 0; u = this._outgoingQueue.shift(); )
          u[0].send(u[1]);
      if (this.children.forEach(function(_) {
        o.state.children[_.id] = _;
      }), this.devTools && this.devTools.send(r.data, e), e.event)
        try {
          for (var l = k(this.eventListeners), h = l.next(); !h.done; h = l.next()) {
            var S = h.value;
            S(e.event);
          }
        } catch (_) {
          n = {
            error: _
          };
        } finally {
          try {
            h && !h.done && (i = l.return) && i.call(l);
          } finally {
            if (n)
              throw n.error;
          }
        }
      try {
        for (var m = k(this.listeners), x = m.next(); !x.done; x = m.next()) {
          var S = x.value;
          S(e, e.event);
        }
      } catch (_) {
        a = {
          error: _
        };
      } finally {
        try {
          x && !x.done && (s = m.return) && s.call(m);
        } finally {
          if (a)
            throw a.error;
        }
      }
      try {
        for (var E = k(this.contextListeners), g = E.next(); !g.done; g = E.next()) {
          var y = g.value;
          y(this.state.context, this.state.history ? this.state.history.context : void 0);
        }
      } catch (_) {
        d = {
          error: _
        };
      } finally {
        try {
          g && !g.done && (f = E.return) && f.call(E);
        } finally {
          if (d)
            throw d.error;
        }
      }
      if (this.state.done) {
        var O = e.configuration.find(function(_) {
          return _.type === "final" && _.parent === o.machine;
        }), b = O && O.doneData ? ye(O.doneData, e.context, r) : void 0;
        this._doneEvent = ne(this.id, b);
        try {
          for (var w = k(this.doneListeners), T = w.next(); !T.done; T = w.next()) {
            var S = T.value;
            S(this._doneEvent);
          }
        } catch (_) {
          p = {
            error: _
          };
        } finally {
          try {
            T && !T.done && (c = w.return) && c.call(w);
          } finally {
            if (p)
              throw p.error;
          }
        }
        this._stop(), this._stopChildren(), B.free(this.sessionId);
      }
    }, t.prototype.onTransition = function(e) {
      return this.listeners.add(e), this.status === I.Running && e(this.state, this.state.event), this;
    }, t.prototype.subscribe = function(e, r, n) {
      var i = this, a = G(e, r, n);
      this.listeners.add(a.next), this.status !== I.NotStarted && a.next(this.state);
      var s = function() {
        i.doneListeners.delete(s), i.stopListeners.delete(s), a.complete();
      };
      return this.status === I.Stopped ? a.complete() : (this.onDone(s), this.onStop(s)), {
        unsubscribe: function() {
          i.listeners.delete(a.next), i.doneListeners.delete(s), i.stopListeners.delete(s);
        }
      };
    }, t.prototype.onEvent = function(e) {
      return this.eventListeners.add(e), this;
    }, t.prototype.onSend = function(e) {
      return this.sendListeners.add(e), this;
    }, t.prototype.onChange = function(e) {
      return this.contextListeners.add(e), this;
    }, t.prototype.onStop = function(e) {
      return this.stopListeners.add(e), this;
    }, t.prototype.onDone = function(e) {
      return this.status === I.Stopped && this._doneEvent ? e(this._doneEvent) : this.doneListeners.add(e), this;
    }, t.prototype.off = function(e) {
      return this.listeners.delete(e), this.eventListeners.delete(e), this.sendListeners.delete(e), this.stopListeners.delete(e), this.doneListeners.delete(e), this.contextListeners.delete(e), this;
    }, t.prototype.start = function(e) {
      var r = this;
      if (this.status === I.Running)
        return this;
      this.machine._init(), B.register(this.sessionId, this), this.initialized = !0, this.status = I.Running;
      var n = e === void 0 ? this.initialState : Q(this, function() {
        return Qe(e) ? r.machine.resolveState(e) : r.machine.resolveState(W.from(e, r.machine.context));
      });
      return this.options.devTools && this.attachDev(), this.scheduler.initialize(function() {
        r.update(n, re);
      }), this;
    }, t.prototype._stopChildren = function() {
      this.children.forEach(function(e) {
        q(e.stop) && e.stop();
      }), this.children.clear();
    }, t.prototype._stop = function() {
      var e, r, n, i, a, s, d, f, p, c;
      try {
        for (var o = k(this.listeners), u = o.next(); !u.done; u = o.next()) {
          var l = u.value;
          this.listeners.delete(l);
        }
      } catch (w) {
        e = {
          error: w
        };
      } finally {
        try {
          u && !u.done && (r = o.return) && r.call(o);
        } finally {
          if (e)
            throw e.error;
        }
      }
      try {
        for (var h = k(this.stopListeners), S = h.next(); !S.done; S = h.next()) {
          var l = S.value;
          l(), this.stopListeners.delete(l);
        }
      } catch (w) {
        n = {
          error: w
        };
      } finally {
        try {
          S && !S.done && (i = h.return) && i.call(h);
        } finally {
          if (n)
            throw n.error;
        }
      }
      try {
        for (var m = k(this.contextListeners), x = m.next(); !x.done; x = m.next()) {
          var l = x.value;
          this.contextListeners.delete(l);
        }
      } catch (w) {
        a = {
          error: w
        };
      } finally {
        try {
          x && !x.done && (s = m.return) && s.call(m);
        } finally {
          if (a)
            throw a.error;
        }
      }
      try {
        for (var E = k(this.doneListeners), g = E.next(); !g.done; g = E.next()) {
          var l = g.value;
          this.doneListeners.delete(l);
        }
      } catch (w) {
        d = {
          error: w
        };
      } finally {
        try {
          g && !g.done && (f = E.return) && f.call(E);
        } finally {
          if (d)
            throw d.error;
        }
      }
      if (!this.initialized)
        return this;
      this.initialized = !1, this.status = I.Stopped, this._initialState = void 0;
      try {
        for (var y = k(Object.keys(this.delayedEventsMap)), O = y.next(); !O.done; O = y.next()) {
          var b = O.value;
          this.clock.clearTimeout(this.delayedEventsMap[b]);
        }
      } catch (w) {
        p = {
          error: w
        };
      } finally {
        try {
          O && !O.done && (c = y.return) && c.call(y);
        } finally {
          if (p)
            throw p.error;
        }
      }
      this.scheduler.clear(), this.scheduler = new ke({
        deferEvents: this.options.deferEvents
      });
    }, t.prototype.stop = function() {
      var e = this, r = this.scheduler;
      return this._stop(), r.schedule(function() {
        var n;
        if (!(!((n = e._state) === null || n === void 0) && n.done)) {
          var i = L({
            type: "xstate.stop"
          }), a = Q(e, function() {
            var s = $e(Se([], ie(e.state.configuration), !1).sort(function(o, u) {
              return u.order - o.order;
            }).map(function(o) {
              return Be(o.onExit, e.machine.options.actions);
            })), d = ie(ze(e.machine, e.state, e.state.context, i, [{
              type: "exit",
              actions: s
            }], e.machine.config.predictableActionArguments ? e._exec : void 0, e.machine.config.predictableActionArguments || e.machine.config.preserveActionOrder), 2), f = d[0], p = d[1], c = new W({
              value: e.state.value,
              context: p,
              _event: i,
              _sessionid: e.sessionId,
              historyValue: void 0,
              history: e.state,
              actions: f.filter(function(o) {
                return !He(o);
              }),
              activities: {},
              events: [],
              configuration: [],
              transitions: [],
              children: {},
              done: e.state.done,
              tags: e.state.tags,
              machine: e.machine
            });
            return c.changed = !0, c;
          });
          e.update(a, i), e._stopChildren(), B.free(e.sessionId);
        }
      }), this;
    }, t.prototype.batch = function(e) {
      var r = this;
      if (this.status === I.NotStarted && this.options.deferEvents)
        D || M(!1, "".concat(e.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, `" and are deferred. Make sure .start() is called for this service.
Event: `).concat(JSON.stringify(event)));
      else if (this.status !== I.Running)
        throw new Error(
          // tslint:disable-next-line:max-line-length
          "".concat(e.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.')
        );
      if (e.length) {
        var n = !!this.machine.config.predictableActionArguments && this._exec;
        this.scheduler.schedule(function() {
          var i, a, s = r.state, d = !1, f = [], p = function(l) {
            var h = L(l);
            r.forward(h), s = Q(r, function() {
              return r.machine.transition(s, h, void 0, n || void 0);
            }), f.push.apply(f, Se([], ie(r.machine.config.predictableActionArguments ? s.actions : s.actions.map(function(S) {
              return ht(S, s);
            })), !1)), d = d || !!s.changed;
          };
          try {
            for (var c = k(e), o = c.next(); !o.done; o = c.next()) {
              var u = o.value;
              p(u);
            }
          } catch (l) {
            i = {
              error: l
            };
          } finally {
            try {
              o && !o.done && (a = c.return) && a.call(c);
            } finally {
              if (i)
                throw i.error;
            }
          }
          s.changed = d, s.actions = f, r.update(s, L(e[e.length - 1]));
        });
      }
    }, t.prototype.sender = function(e) {
      return this.send.bind(this, e);
    }, t.prototype._nextState = function(e, r) {
      var n = this;
      r === void 0 && (r = !!this.machine.config.predictableActionArguments && this._exec);
      var i = L(e);
      if (i.name.indexOf(ge) === 0 && !this.state.nextEvents.some(function(s) {
        return s.indexOf(ge) === 0;
      }))
        throw i.data.data;
      var a = Q(this, function() {
        return n.machine.transition(n.state, i, void 0, r || void 0);
      });
      return a;
    }, t.prototype.nextState = function(e) {
      return this._nextState(e, !1);
    }, t.prototype.forward = function(e) {
      var r, n;
      try {
        for (var i = k(this.forwardTo), a = i.next(); !a.done; a = i.next()) {
          var s = a.value, d = this.children.get(s);
          if (!d)
            throw new Error("Unable to forward event '".concat(e, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(s, "'."));
          d.send(e);
        }
      } catch (f) {
        r = {
          error: f
        };
      } finally {
        try {
          a && !a.done && (n = i.return) && n.call(i);
        } finally {
          if (r)
            throw r.error;
        }
      }
    }, t.prototype.defer = function(e) {
      var r = this, n = this.clock.setTimeout(function() {
        "to" in e && e.to ? r.sendTo(e._event, e.to, !0) : r.send(e._event);
      }, e.delay);
      e.id && (this.delayedEventsMap[e.id] = n);
    }, t.prototype.cancel = function(e) {
      this.clock.clearTimeout(this.delayedEventsMap[e]), delete this.delayedEventsMap[e];
    }, t.prototype.exec = function(e, r, n) {
      n === void 0 && (n = this.machine.options.actions), this._exec(e, r.context, r._event, n);
    }, t.prototype.removeChild = function(e) {
      var r;
      this.children.delete(e), this.forwardTo.delete(e), (r = this.state) === null || r === void 0 || delete r.children[e];
    }, t.prototype.stopChild = function(e) {
      var r = this.children.get(e);
      r && (this.removeChild(e), q(r.stop) && r.stop());
    }, t.prototype.spawn = function(e, r, n) {
      if (this.status !== I.Running)
        return Ge(e, r);
      if (xe(e))
        return this.spawnPromise(Promise.resolve(e), r);
      if (q(e))
        return this.spawnCallback(e, r);
      if (Ke(e))
        return this.spawnActor(e, r);
      if (We(e))
        return this.spawnObservable(e, r);
      if (be(e))
        return this.spawnMachine(e, R(R({}, n), {
          id: r
        }));
      if (Je(e))
        return this.spawnBehavior(e, r);
      throw new Error('Unable to spawn entity "'.concat(r, '" of type "').concat(typeof e, '".'));
    }, t.prototype.spawnMachine = function(e, r) {
      var n = this;
      r === void 0 && (r = {});
      var i = new t(e, R(R({}, this.options), {
        parent: this,
        id: r.id || e.id
      })), a = R(R({}, Bt), r);
      a.sync && i.onTransition(function(d) {
        n.send(Ye, {
          state: d,
          id: i.id
        });
      });
      var s = i;
      return this.children.set(i.id, s), a.autoForward && this.forwardTo.add(i.id), i.onDone(function(d) {
        n.removeChild(i.id), n.send(L(d, {
          origin: i.id
        }));
      }).start(), s;
    }, t.prototype.spawnBehavior = function(e, r) {
      var n = $t(e, {
        id: r,
        parent: this
      });
      return this.children.set(r, n), n;
    }, t.prototype.spawnPromise = function(e, r) {
      var n, i = this, a = !1, s;
      e.then(function(f) {
        a || (s = f, i.removeChild(r), i.send(L(ne(r, f), {
          origin: r
        })));
      }, function(f) {
        if (!a) {
          i.removeChild(r);
          var p = z(r, f);
          try {
            i.send(L(p, {
              origin: r
            }));
          } catch (c) {
            Xe(f, c, r), i.devTools && i.devTools.send(p, i.state), i.machine.strict && i.stop();
          }
        }
      });
      var d = (n = {
        id: r,
        send: function() {
        },
        subscribe: function(f, p, c) {
          var o = G(f, p, c), u = !1;
          return e.then(function(l) {
            u || (o.next(l), !u && o.complete());
          }, function(l) {
            u || o.error(l);
          }), {
            unsubscribe: function() {
              return u = !0;
            }
          };
        },
        stop: function() {
          a = !0;
        },
        toJSON: function() {
          return {
            id: r
          };
        },
        getSnapshot: function() {
          return s;
        }
      }, n[$] = function() {
        return this;
      }, n);
      return this.children.set(r, d), d;
    }, t.prototype.spawnCallback = function(e, r) {
      var n, i = this, a = !1, s = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Set(), f, p = function(u) {
        f = u, d.forEach(function(l) {
          return l(u);
        }), !a && i.send(L(u, {
          origin: r
        }));
      }, c;
      try {
        c = e(p, function(u) {
          s.add(u);
        });
      } catch (u) {
        this.send(z(r, u));
      }
      if (xe(c))
        return this.spawnPromise(c, r);
      var o = (n = {
        id: r,
        send: function(u) {
          return s.forEach(function(l) {
            return l(u);
          });
        },
        subscribe: function(u) {
          var l = G(u);
          return d.add(l.next), {
            unsubscribe: function() {
              d.delete(l.next);
            }
          };
        },
        stop: function() {
          a = !0, q(c) && c();
        },
        toJSON: function() {
          return {
            id: r
          };
        },
        getSnapshot: function() {
          return f;
        }
      }, n[$] = function() {
        return this;
      }, n);
      return this.children.set(r, o), o;
    }, t.prototype.spawnObservable = function(e, r) {
      var n, i = this, a, s = e.subscribe(function(f) {
        a = f, i.send(L(f, {
          origin: r
        }));
      }, function(f) {
        i.removeChild(r), i.send(L(z(r, f), {
          origin: r
        }));
      }, function() {
        i.removeChild(r), i.send(L(ne(r), {
          origin: r
        }));
      }), d = (n = {
        id: r,
        send: function() {
        },
        subscribe: function(f, p, c) {
          return e.subscribe(f, p, c);
        },
        stop: function() {
          return s.unsubscribe();
        },
        getSnapshot: function() {
          return a;
        },
        toJSON: function() {
          return {
            id: r
          };
        }
      }, n[$] = function() {
        return this;
      }, n);
      return this.children.set(r, d), d;
    }, t.prototype.spawnActor = function(e, r) {
      return this.children.set(r, e), e;
    }, t.prototype.spawnActivity = function(e) {
      var r = this.machine.options && this.machine.options.activities ? this.machine.options.activities[e.type] : void 0;
      if (!r) {
        D || M(!1, "No implementation found for activity '".concat(e.type, "'"));
        return;
      }
      var n = r(this.state.context, e);
      this.spawnEffect(e.id, n);
    }, t.prototype.spawnEffect = function(e, r) {
      var n;
      this.children.set(e, (n = {
        id: e,
        send: function() {
        },
        subscribe: function() {
          return {
            unsubscribe: function() {
            }
          };
        },
        stop: r || void 0,
        getSnapshot: function() {
        },
        toJSON: function() {
          return {
            id: e
          };
        }
      }, n[$] = function() {
        return this;
      }, n));
    }, t.prototype.attachDev = function() {
      var e = me();
      if (this.options.devTools && e) {
        if (e.__REDUX_DEVTOOLS_EXTENSION__) {
          var r = typeof this.options.devTools == "object" ? this.options.devTools : void 0;
          this.devTools = e.__REDUX_DEVTOOLS_EXTENSION__.connect(R(R({
            name: this.id,
            autoPause: !0,
            stateSanitizer: function(n) {
              return {
                value: n.value,
                context: n.context,
                actions: n.actions
              };
            }
          }, r), {
            features: R({
              jump: !1,
              skip: !1
            }, r ? r.features : void 0)
          }), this.machine), this.devTools.init(this.state);
        }
        Qt(this);
      }
    }, t.prototype.toJSON = function() {
      return {
        id: this.id
      };
    }, t.prototype[$] = function() {
      return this;
    }, t.prototype.getSnapshot = function() {
      return this.status === I.NotStarted ? this.initialState : this._state;
    }, t.defaultOptions = {
      execute: !0,
      deferEvents: !0,
      clock: {
        setTimeout: function(e, r) {
          return setTimeout(e, r);
        },
        clearTimeout: function(e) {
          return clearTimeout(e);
        }
      },
      logger: /* @__PURE__ */ console.log.bind(console),
      devTools: !1
    }, t.interpret = Ve, t;
  }()
);
function Ve(t, e) {
  var r = new zt(t, e);
  return r;
}
var Ht = bt;
function Le(t) {
  var e = De.useRef();
  return e.current || (e.current = { v: t() }), e.current.v;
}
var X = globalThis && globalThis.__assign || function() {
  return X = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, X.apply(this, arguments);
}, Gt = globalThis && globalThis.__rest || function(t, e) {
  var r = {};
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(t); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[i]) && (r[n[i]] = t[n[i]]);
  return r;
}, Kt = globalThis && globalThis.__read || function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r)
    return t;
  var n = r.call(t), i, a = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; )
      a.push(i.value);
  } catch (d) {
    s = { error: d };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return a;
};
function Wt(t, e) {
  var r = Le(function() {
    return typeof t == "function" ? t() : t;
  });
  if (process.env.NODE_ENV !== "production" && typeof t != "function") {
    var n = Kt(ve(r), 1), i = n[0];
    t !== i && console.warn("Machine given to `useMachine` has changed between renders. This is not supported and might lead to unexpected results.\nPlease make sure that you pass the same Machine as argument each time.");
  }
  var a = e.context, s = e.guards, d = e.actions, f = e.activities, p = e.services, c = e.delays;
  e.state;
  var o = Gt(e, ["context", "guards", "actions", "activities", "services", "delays", "state"]), u = Le(function() {
    var l = {
      context: a,
      guards: s,
      actions: d,
      activities: f,
      services: p,
      delays: c
    }, h = r.withConfig(l, function() {
      return X(X({}, r.context), a);
    });
    return Ve(h, o);
  });
  return Ht(function() {
    Object.assign(u.machine.options.actions, d), Object.assign(u.machine.options.guards, s), Object.assign(u.machine.options.activities, f), Object.assign(u.machine.options.services, p), Object.assign(u.machine.options.delays, c);
  }, [d, s, f, p, c]), u;
}
globalThis && globalThis.__read;
globalThis && globalThis.__values;
function Jt(t, e, r) {
  if (t.status === I.NotStarted)
    return !0;
  var n = r.changed === void 0 && (Object.keys(r.children).length > 0 || typeof e.changed == "boolean");
  return !(r.changed || n);
}
var Yt = globalThis && globalThis.__read || function(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r)
    return t;
  var n = r.call(t), i, a = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; )
      a.push(i.value);
  } catch (d) {
    s = { error: d };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return a;
};
function Xt(t) {
  return t;
}
function Zt(t) {
  for (var e = [], r = 1; r < arguments.length; r++)
    e[r - 1] = arguments[r];
  var n = Yt(e, 1), i = n[0], a = i === void 0 ? {} : i, s = Wt(t, a), d = se(function() {
    return s.status === I.NotStarted ? a.state ? W.create(a.state) : s.machine.initialState : s.getSnapshot();
  }, [s]), f = se(function(o, u) {
    return Jt(s, o, u);
  }, [s]), p = se(function(o) {
    var u = s.subscribe(o).unsubscribe;
    return u;
  }, [s]), c = Vt.useSyncExternalStoreWithSelector(p, d, d, Xt, f);
  return wt(function() {
    var o = a.state;
    return s.start(o ? W.create(o) : void 0), function() {
      s.stop(), s.status = I.NotStarted;
    };
  }, []), [c, s.send, s];
}
var er = Ae, tr = pt, rr = vt;
function nr(t) {
  return function(e, r, n) {
    var i = Object(e);
    if (!tr(e)) {
      var a = er(r);
      e = rr(e), r = function(d) {
        return a(i[d], d, i);
      };
    }
    var s = t(e, r, n);
    return s > -1 ? i[a ? e[s] : s] : void 0;
  };
}
var ir = nr;
function sr(t, e, r, n) {
  for (var i = t.length, a = r + (n ? 1 : -1); n ? a-- : ++a < i; )
    if (e(t[a], a, t))
      return a;
  return -1;
}
var or = sr, ar = mt, je = 1 / 0, ur = 17976931348623157e292;
function cr(t) {
  if (!t)
    return t === 0 ? t : 0;
  if (t = ar(t), t === je || t === -je) {
    var e = t < 0 ? -1 : 1;
    return e * ur;
  }
  return t === t ? t : 0;
}
var lr = cr, dr = lr;
function fr(t) {
  var e = dr(t), r = e % 1;
  return e === e ? r ? e - r : e : 0;
}
var hr = fr, pr = or, vr = Ae, mr = hr, yr = Math.max;
function Sr(t, e, r) {
  var n = t == null ? 0 : t.length;
  if (!n)
    return -1;
  var i = r == null ? 0 : mr(r);
  return i < 0 && (i = yr(n + i, 0)), pr(t, vr(e), i);
}
var gr = Sr, xr = ir, br = gr, wr = xr(br), _r = wr;
const P = /* @__PURE__ */ xt(_r), Er = (t) => /* @__PURE__ */ v.jsxs(
  At,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "81px",
    height: "80px",
    viewBox: "0 0 81 80",
    fill: "none",
    ...t,
    children: [
      /* @__PURE__ */ v.jsx(
        "path",
        {
          d: "M75.125 6.62524C75.375 6.50024 74.625 6.50024 74.625 6.50024C74.125 6.50024 73.625 6.62524 73.125 6.75024C71.625 7.00024 70.125 7.25024 68.75 7.50024C65 8.12524 61.125 8.75024 57.25 9.37524C48.625 10.7502 40.125 12.6252 31.625 14.6252C28 15.5002 23.5 15.8752 20.25 17.6252C19.625 18.0002 21 18.5002 21.25 18.6252C23 19.3752 24.875 20.0002 26.625 20.8752C29.125 22.2502 31.625 24.0002 33.875 25.6252C34.25 25.8752 35.625 27.5002 36.125 27.5002",
          stroke: "black",
          "stroke-width": "2.45",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ v.jsx(
        "path",
        {
          d: "M75.1252 6.75049C75.1252 6.75049 74.7502 8.62549 74.3752 9.75049C71.7502 18.2505 68.3752 26.2505 67.1252 35.1255C65.7502 44.6255 65.7502 43.7505 65.7502 43.6255",
          stroke: "black",
          "stroke-width": "2.45",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ v.jsx(
        "path",
        {
          d: "M66.0002 43.5002C66.1252 43.5002 65.8752 43.5002 65.7502 43.5002C59.8752 40.0002 54.1252 36.2502 48.0002 33.3752C46.6252 32.7502 45.1252 32.2502 43.8752 31.5002",
          stroke: "black",
          "stroke-width": "2.45",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ v.jsx(
        "path",
        {
          d: "M43.8757 31.5001C43.8757 31.6251 44.2507 31.2501 44.2507 31.2501C44.5007 31.0001 44.6257 30.7501 44.8757 30.5001C47.3757 27.7501 50.3757 25.7501 53.2507 23.5001C58.0007 19.7501 63.1257 16.2501 67.8757 12.5001C69.5007 11.2501 71.0007 10.0001 72.6257 8.75009C73.2507 8.25009 75.0007 6.87509 74.8757 6.75009C74.7507 6.62509 74.3757 6.87509 74.2507 6.87509C71.1257 8.12509 68.0007 9.50009 65.1257 11.1251C60.1257 13.8751 55.0007 16.7501 49.8757 19.5001C47.2507 21.0001 44.5007 22.2501 42.0007 23.8751C40.2507 24.8751 37.0007 26.3751 35.6257 27.7501",
          stroke: "black",
          "stroke-width": "2.45",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ v.jsx(
        "path",
        {
          d: "M35.7502 27.8748C35.7502 27.8748 35.7502 28.7498 35.7502 28.8748C35.7502 30.1248 35.8752 31.2498 35.8752 32.4998C36.0002 35.9998 36.6252 39.3748 36.7502 42.8748C36.7502 44.2498 36.7502 45.6248 37.0002 46.9998C37.0002 46.9998 37.1252 48.2498 37.3752 48.1248C37.7502 47.9998 37.7502 46.8748 37.8752 46.6248C38.2502 45.2498 38.6252 43.8748 39.1252 42.4998C39.6252 41.1248 40.2502 39.6248 40.7502 38.2498C41.3752 36.6248 42.1252 35.1248 42.8752 33.4998C43.2502 32.7498 43.6252 31.7498 44.2502 31.1248",
          stroke: "black",
          "stroke-width": "2.45",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ v.jsx(
        "path",
        {
          d: "M37.563 48.3755C37.563 48.0005 38.188 47.6255 38.438 47.3755C39.188 46.5005 40.0468 45.9068 40.7968 45.0318C43.1718 42.5318 46.063 40.3755 48.563 38.0005C49.438 37.1255 50.313 36.6255 50.938 35.5005",
          stroke: "black",
          "stroke-width": "2.45",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ v.jsx("path", { d: "M45.5 32.5L49.875 36.25", stroke: "black", "stroke-width": "2.45" }),
      /* @__PURE__ */ v.jsx(
        "path",
        {
          d: "M26.3752 35.5005C17.0002 37.2505 6.37524 47.3755 10.3752 57.3755C10.8752 58.5005 11.5002 59.6255 12.3752 60.5005C18.1252 66.0005 26.1252 59.1255 27.8752 53.2505C28.0002 52.6255 28.1252 52.1255 28.0002 51.5005C27.7502 50.3755 26.5002 49.5005 25.2502 49.5005C24.0002 49.5005 22.8752 50.0005 21.8752 50.6255C14.6252 55.1255 10.2502 69.5005 19.2502 74.5005",
          stroke: "black",
          "stroke-width": "2.45",
          "stroke-miterlimit": "10",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
), A = "NPS", Or = () => /* @__PURE__ */ v.jsxs(Ne, { children: [
  /* @__PURE__ */ v.jsx(Er, { width: "80x", height: "80px" }),
  /* @__PURE__ */ v.jsx(
    Et,
    {
      fontSize: "32px",
      fontWeight: "light",
      lineHeight: "39.68px",
      letterSpacing: "-0.352px",
      children: /* @__PURE__ */ v.jsx(
        j,
        {
          text: "Thanks for your feedback",
          translationKey: `${A}/completedHeading`
        }
      )
    }
  ),
  /* @__PURE__ */ v.jsx(J, { fontSize: "lg", lineHeight: "22.32px", children: /* @__PURE__ */ v.jsx(
    j,
    {
      text: "Your feedback is a huge part of improving the experience.",
      translationKey: `${A}/completedMessage`
    }
  ) })
] }), Tr = ({
  loading: t = !1,
  category: e = "PASSIVE",
  description: r = "",
  reasons: n = [],
  onSubmit: i
}) => {
  const [a, s] = ve([]);
  return (
    // remove height here
    /* @__PURE__ */ v.jsxs(K, { flexFlow: "column nowrap", align: "left", justify: "space-between", h: "700px", children: [
      /* @__PURE__ */ v.jsxs(Y, { p: 4, children: [
        /* @__PURE__ */ v.jsx(
          J,
          {
            fontSize: "2xl",
            fontWeight: "light",
            letterSpacing: "-0.264px",
            lineHeight: "31.68px",
            children: /* @__PURE__ */ v.jsx(
              j,
              {
                text: r,
                translationKey: `${A}/ReasonDescription`
              }
            )
          }
        ),
        /* @__PURE__ */ v.jsx(
          Ot,
          {
            isDisabled: t,
            onChange: (d) => s(d),
            children: /* @__PURE__ */ v.jsx(Ne, { spacing: 3, direction: "column", pt: 4, children: n.map((d, f) => /* @__PURE__ */ v.jsx(
              Tt,
              {
                colorScheme: "blackAlpha",
                borderColor: "brand.secondary",
                _checked: {
                  "& .chakra-checkbox__control": {
                    background: "brand.black",
                    border: "none"
                  }
                },
                value: d,
                children: /* @__PURE__ */ v.jsx(
                  j,
                  {
                    text: d,
                    translationKey: `${A}/reason${e}${f}`
                  }
                )
              },
              `${f}-reason`
            )) })
          }
        )
      ] }),
      /* @__PURE__ */ v.jsx(Y, { py: 6, px: 4, boxShadow: "0px -4px 8px 0px rgba(0, 0, 0, 0.04)", children: /* @__PURE__ */ v.jsx(
        Me,
        {
          isDisabled: a.length < 1,
          isLoading: t,
          colorScheme: "primary",
          fontWeight: "bold",
          borderRadius: 8,
          w: "full",
          onClick: () => i(a),
          children: /* @__PURE__ */ v.jsx(j, { text: "Submit", translationKey: `${A}/submitButtonText` })
        }
      ) })
    ] })
  );
}, Cr = {
  mt: "-9",
  ml: "-1",
  fontWeight: "bold"
}, Ir = ({
  defaultScore: t = 1,
  onSubmit: e,
  useBrandStyle: r = !1
}) => {
  var p, c;
  const [n, i] = ve(t), { data: a } = yt(), { theme: s } = a, { colors: d } = s, f = ((c = (p = d == null ? void 0 : d.brand) == null ? void 0 : p.neutral) == null ? void 0 : c.deep) || "";
  return console.log("NPSSlider useBrandStyle", r, f), /* @__PURE__ */ v.jsxs(K, { flexFlow: "column wrap", align: "left", justify: "space-between", h: "700px", children: [
    /* @__PURE__ */ v.jsxs(Y, { p: 4, children: [
      /* @__PURE__ */ v.jsxs(K, { flexFlow: "column wrap", gap: 2, mb: 2, children: [
        /* @__PURE__ */ v.jsx(
          J,
          {
            fontSize: "32px",
            fontWeight: "light",
            lineHeight: "39.68px",
            letterSpacing: "-0.352px",
            children: /* @__PURE__ */ v.jsx(
              j,
              {
                text: "Your feedback is important to us",
                translationKey: `${A}/sliderTitle`
              }
            )
          }
        ),
        /* @__PURE__ */ v.jsx(J, { fontSize: "lg", lineHeight: "22.32px", children: /* @__PURE__ */ v.jsx(
          j,
          {
            text: "How likely are you to recommend to your friends and family?",
            translationKey: `${A}/sliderDescription`
          }
        ) })
      ] }),
      /* @__PURE__ */ v.jsxs(K, { flexFlow: "column wrap", py: "10px", gap: "40px", px: 4, children: [
        /* @__PURE__ */ v.jsxs(Ct, { fontSize: "lg", color: "primary.500", fontWeight: "bold", pt: "10px", children: [
          n > 8 && /* @__PURE__ */ v.jsx(
            j,
            {
              text: "Extremely likely",
              translationKey: `${A}/sliderHighLabel`
            }
          ),
          8 >= n && n > 6 && /* @__PURE__ */ v.jsx(
            j,
            {
              text: "Likely",
              translationKey: `${A}/sliderMedianLabel`
            }
          ),
          6 >= n && n > 0 && /* @__PURE__ */ v.jsx(
            j,
            {
              text: "Not at all likely",
              translationKey: `${A}/sliderLowLabel`
            }
          )
        ] }),
        /* @__PURE__ */ v.jsxs(
          It,
          {
            defaultValue: t,
            min: 1,
            max: 10,
            step: 1,
            onChange: (o) => i(o),
            children: [
              [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((o, u) => /* @__PURE__ */ v.jsx(
                Rt,
                {
                  value: o,
                  fontSize: n === o ? "xl" : "sm",
                  color: n === o ? "primary.500" : "",
                  top: n === o ? "1" : "",
                  ...Cr,
                  children: o
                },
                u
              )),
              /* @__PURE__ */ v.jsx(kt, { bg: "#EDEDED", h: "7px", borderRadius: 8, children: /* @__PURE__ */ v.jsx(Lt, { bg: r ? f : "primary.500" }) }),
              /* @__PURE__ */ v.jsx(
                jt,
                {
                  boxSize: 5,
                  bg: r ? f : "primary.500",
                  _focus: { boxShadow: "none" }
                }
              )
            ]
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(Y, { py: 6, px: 4, boxShadow: "0px -4px 8px 0px rgba(0, 0, 0, 0.04)", children: /* @__PURE__ */ v.jsx(
      Me,
      {
        w: "full",
        colorScheme: "primary",
        fontWeight: "bold",
        borderRadius: 8,
        onClick: () => e(n),
        children: /* @__PURE__ */ v.jsx(j, { text: "Next", translationKey: `${A}/nextButtonText` })
      }
    ) })
  ] });
}, de = {
  DETRACTOR: [
    "Takes a long time to do what I want",
    "Portal was difficult to use",
    "SmartSupport was not able to address my issue",
    "Unsatisfied with service request processing",
    "Inflexible delivery arrangement"
    // 'Agent was not helpful in handling my request / query',
  ],
  PASSIVE: [
    "Time spent on getting what I want",
    "Ease of getting what I want",
    "Usefulness of SmartSupport to address my issue",
    "Satisfaction with service request processing",
    "Flexibility with delivery arrangement",
    "Satisfaction with customer service"
  ],
  PROMOTER: [
    "Minimal time spent to do what I want",
    "Portal was easy to use",
    "SmartSupport was able to address my concern",
    "Satisfied with service request processing",
    "Flexible delivery arrangement"
    // 'Agent was friendly and helpful in handling my request / query',
  ]
}, fe = (t) => {
  switch (t) {
    case "starhub":
      return {
        DETRACTOR: [
          "Takes a long time to do what I want",
          "Portal was difficult to use",
          "SmartSupport was not able to address my issue",
          "Unsatisfied with service request processing",
          "Inflexible delivery arrangement"
        ],
        PASSIVE: [
          "Time spent on getting what I want",
          "Ease of getting what I want",
          "Usefulness of SmartSupport to address my issue",
          "Satisfaction with service request processing",
          "Flexibility with delivery arrangement",
          "Satisfaction with customer service"
        ],
        PROMOTER: [
          "Minimal time spent to do what I want",
          "Portal was easy to use",
          "SmartSupport was able to address my concern",
          "Satisfied with service request processing",
          "Flexible delivery arrangement"
        ]
      };
    case "asurion_techcare":
      return {
        DETRACTOR: [
          "Takes a long time to do what I want",
          "Site was difficult to use",
          "Service was not able to address my issue",
          "Unsatisfied with service request processing",
          "Inflexible delivery arrangement"
        ],
        PASSIVE: [
          "Time spent on getting what I want",
          "Ease of getting what I want",
          "Usefulness of service to address my issue",
          "Satisfaction with service request processing",
          "Flexibility with delivery arrangement",
          "Satisfaction with customer service"
        ],
        PROMOTER: [
          "Minimal time spent to do what I want",
          "Site is easy to use",
          "Handle errors well and help available",
          "Able to address my issues",
          "Satisfied with service request processing",
          "Flexible delivery arrangement"
        ]
      };
    default:
      return {
        DETRACTOR: [
          "Takes a long time to do what I want",
          "Site was difficult to use",
          "Service was not able to address my issue",
          "Unsatisfied with service request processing",
          "Inflexible delivery arrangement"
        ],
        PASSIVE: [
          "Time spent on getting what I want",
          "Ease of getting what I want",
          "Usefulness of service to address my issue",
          "Satisfaction with service request processing",
          "Flexibility with delivery arrangement",
          "Satisfaction with customer service"
        ],
        PROMOTER: [
          "Minimal time spent to do what I want",
          "Site is easy to use",
          "Handle errors well and help available",
          "Able to address my issues",
          "Satisfied with service request processing",
          "Flexible delivery arrangement"
        ]
      };
  }
}, { useEffect: he } = De, Rr = "SR_Creation", kr = "NPS", on = ({
  clientId: t,
  triggerPoint: e = Rr,
  surveyType: r = kr,
  serviceRequestId: n = "",
  customerCaseNumber: i = "",
  sessionId: a = "",
  language: s = "en-US",
  mdn: d = "",
  config: f,
  onSubmit: p = Ee.noop,
  onError: c = Ee.noop,
  defaultScore: o = 10,
  useBrandStyle: u = !1
}) => {
  const [l, h] = Zt(St, {
    devTools: !1,
    services: {
      async getSurvey() {
        var E, g, y, O, b, w, T, _;
        const { data: m } = await _e({
          baseURL: f.baseUrl,
          url: f.actions.getSurvey.path,
          headers: f.headers,
          method: f.actions.getSurvey.method,
          data: {
            GetSurveyQuestions: {
              ClientId: t,
              TriggerPoint: e,
              SurveyType: r,
              ServiceRequestId: n,
              Language: s,
              SessionId: a
            }
          }
        }), x = gt(
          (m == null ? void 0 : m.SurveyQuestions) || ((E = m.GetSurveyQuestionsResponse) == null ? void 0 : E.SurveyQuestions),
          [(C) => parseInt(C.DisplayOrder)]
        );
        return h("SET_CLIENT_ID", { id: t }), h("SET_SURVEY_ID", { id: x[0].SurveyId }), h("SET_SCORE_QUESTION_ID", {
          id: (g = P(x, { QuestionType: "NPS", QuestionOptions: "slider" })) == null ? void 0 : g.QuestionId
        }), h("SET_MDN", { mdn: d }), {
          PROMOTER: {
            questionId: (y = P(
              x,
              (C) => C.QuestionType.toLowerCase() === "promoter"
            )) == null ? void 0 : y.QuestionId,
            description: (O = P(
              x,
              (C) => C.QuestionType.toLowerCase() === "promoter"
            )) == null ? void 0 : O.QuestionDescription,
            reasons: fe(S).PROMOTER ?? de.PROMOTER
          },
          PASSIVE: {
            questionId: (b = P(
              x,
              (C) => C.QuestionType.toLowerCase() === "passive"
            )) == null ? void 0 : b.QuestionId,
            description: (w = P(
              x,
              (C) => C.QuestionType.toLowerCase() === "passive"
            )) == null ? void 0 : w.QuestionDescription,
            reasons: fe(S).PASSIVE ?? de.PASSIVE
          },
          DETRACTOR: {
            questionId: (T = P(
              x,
              (C) => C.QuestionType.toLowerCase() === "detractor"
            )) == null ? void 0 : T.QuestionId,
            description: (_ = P(
              x,
              (C) => C.QuestionType.toLowerCase() === "detractor"
            )) == null ? void 0 : _.QuestionDescription,
            reasons: fe(S).DETRACTOR ?? de.DETRACTOR
          }
        };
      },
      async submitSurvey(m) {
        let x = [];
        return m.customerCategory !== null && m.score !== null && (x = [
          {
            QuestionId: m.scoreQuestionId,
            Answer: m.score.toString()
          },
          {
            QuestionId: m.reasons[m.customerCategory].questionId,
            Answer: m.selectedReasons.join(",")
          }
        ]), (await _e({
          baseURL: f.baseUrl,
          url: f.actions.submitSurvey.path,
          headers: f.headers,
          method: f.actions.submitSurvey.method,
          data: {
            SubmitSurveyAnswers: {
              SurveyId: m.surveyId,
              ClientId: m.clientId,
              // engagementId: '',
              // mobileNumber: context.mdn,
              // InteractionLineId: '',
              Results: x,
              // CacheId: '',
              CustomerCaseNumber: i,
              ServiceRequestId: n
            }
          }
        })).data;
      }
    }
  }), S = _t();
  return he(() => {
    t && h("FETCH");
  }, [t]), he(() => {
    l.context.surveyResult && (p == null || p(l.context.surveyResult));
  }, [l.context.surveyResult]), he(() => {
    l.context.errors && (c == null || c(l.context.errors));
  }, [l.context.errors]), /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    l.matches("fetchingSurvey") && l.hasTag("loading") && /* @__PURE__ */ v.jsx(Fe, { alignSelf: "center", justifySelf: "center" }),
    l.matches("surveyUnavailable") && /* @__PURE__ */ v.jsx(v.Fragment, { children: "Survey not available" }),
    l.matches("selectScore") && /* @__PURE__ */ v.jsx(
      Ir,
      {
        defaultScore: o,
        onSubmit: (m) => {
          h("SET_SCORE", { score: m }), h("SUBMIT_SCORE");
        },
        useBrandStyle: u
      }
    ),
    (l.matches("selectReason") || l.matches("submittingSurvey")) && /* @__PURE__ */ v.jsx(
      Tr,
      {
        category: l.context.customerCategory,
        loading: l.hasTag("loading"),
        description: l.context.customerCategory === null ? "" : l.context.reasons[l.context.customerCategory].description,
        reasons: l.context.customerCategory === null ? [] : l.context.reasons[l.context.customerCategory].reasons,
        onSubmit: (m) => {
          h("UPDATE_REASONS", { selectedReasons: m }), h("SUBMIT_NPS");
        }
      }
    ),
    l.matches("surveySubmitted") && /* @__PURE__ */ v.jsx(Or, {})
  ] });
};
export {
  Or as Completed,
  on as NPS,
  Tr as NPSReasons,
  Ir as NPSSlider,
  A as PAGE_NAME
};
